module.exports = __webpack_public_path__ + "img/rb.0173d38a.svg";